export default "__VITE_ASSET__BVA7NUpz__"